import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    standalone: true,
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    imports: []
})
export class PageNotFoundComponent implements OnInit {
  private router = inject(Router);

  error: string;

  ngOnInit() {
  }

  gotoHome() {
    this.router.navigate(['/']);
  }
}
